<template>
  <div class="scan">
    <date></date>
    <!-- <span class="mainText">欢迎使用档案馆预约管理系统</span> -->
    <!-- <div class="numBox">
      <div class="number" v-for="(num,index) in number" :key="index">{{num}}</div>
    </div> -->
  </div>
</template>

<script>
import date from "./date";

export default {
  components: {
    date,
  },
  data() {
    return {
      number: "00000",
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      // console.log("scanTimes", data);
      // this.number = String(data);
      // if (this.number.length < 5) {
      //   this.number = (Array(5).join(0) + this.number).slice(-5);
      // }
    },
  },
};
</script>
<style lang="scss">
.scan {
  text-align: center;
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -56%);
  transform: translate(-50%, -57%);
  .mainText {
    // font-weight: bold;
    font-size: 48px;
    letter-spacing: 4px;
    @media screen and (max-width: 767px){
      font-size: 28px;
    }
  }
  .numBox {
    height: 85px;
    @media screen and (max-width: 767px){
      height: 60px;
    }
    .number {
      display: inline-block;
      margin: 20px 6px;
      background: #0198ff;
      color: #fff;
      height: 60px;
      width: 50px;
      line-height: 60px;
      font-size: 52px;
      white-space: nowrap;
      @media screen and (max-width: 767px){
        font-size: 40px;
        height: 50px;
        line-height: 50px;
        width: 40px;
      }
    }
  }
}
</style>